var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type === 'white')?_c('div',{class:{circle: true, warn: _vm.warning? true: false}}):_vm._e(),(_vm.type === 'blue')?_c('div',{staticClass:"blue"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }